<div class="table-row">
	@let
	r = getDataRow();
	@if (showDate()) {
		<div>{{row().date | date: 'HH:mm'}}</div>
	}

	<div class="font-decimaBold">{{r.body.join(', ')}}</div>


</div>